import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _orderBy from 'lodash/orderBy';
// Serialization
import { deserialize, serialize } from 'serializr';
import { profileSchema } from './schemas';
// Permissions
import permissions from '../constants/Permissions';
// Custom
import { SEARCHFIELD_TYPES } from '../constants/App';

/**
* Serialization
*/
const serializerKey = 'profile';

const deserializeProfile = (data) => deserialize(profileSchema, data);

const serializeProfile = ({ product, name, permissions: permissionsList }) => ({
  [serializerKey]: {
    ...serialize(profileSchema, {
      product: _defaultTo(product, null),
      name: _defaultTo(name, null),
      ...(permissionsList && { permissions: permissionsList }),
    }),
  },
});

/**
* Utils
*/
const sortProfiles = (profiles, fields = ['name'], dirs = ['asc']) => (_orderBy(profiles, fields, dirs));

const profileTitle = (profileData) => _get(profileData, 'name', '');

/**
* Model
*/
const profile = {
  // Name and icon
  name: 'profile',
  icon: 'profile',

  // Serialization
  deserialize: deserializeProfile,
  serialize: serializeProfile,

  // Sort elements
  sortElements: sortProfiles,

  // Utils
  title: profileTitle,

  // List features
  listFeatures: {
    // Default list params
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [
        { field: 'name', dir: 'asc' },
      ],
    },

    // Autocomplete filter
    autoCompleteFilter: {
      field: 'name',
      operator: SEARCHFIELD_TYPES.string.defaultOperator(),
    },

    // Columns
    columnsQuantity: (hasPermission) => ({
      xs: 1 + (hasPermission({ needed: permissions.pAdmin }) | 0),
      sm: 2 + (hasPermission({ needed: permissions.pAdmin }) | 0),
      md: 2 + (hasPermission({ needed: permissions.pAdmin }) | 0),
      lg: 2 + (hasPermission({ needed: permissions.pAdmin }) | 0),
      xl: 2 + (hasPermission({ needed: permissions.pAdmin }) | 0),
    }),
    columns: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        sortable: true,
      },
      {
        key: 'product',
        permissions: {
          needed: permissions.pAdmin,
        },
        labelId: 'field.product',
        field: 'product',
        sortable: false,
      },
      {
        key: 'permissions',
        labelId: 'field.permissions',
        field: 'permissions',
        sortable: false,
        className: 'table-content-2',
      },
    ],

    // Search fields
    searchFields: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        filter: {
          field: 'name',
        },
      },
      {
        key: 'product',
        permissions: {
          needed: permissions.pAdmin,
        },
        labelId: 'field.product',
        field: 'product',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'product',
        },
      },
    ],
  },
};

module.exports = profile;



// WEBPACK FOOTER //
// ./models/profile.js